// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InnerContent_wrapper__n6_ZU","hide":"InnerContent_hide__G2Ug4"};